import { render, staticRenderFns } from "./reply-loading.vue?vue&type=template&id=6cbd1fdb&scoped=true"
import script from "./reply-loading.vue?vue&type=script&lang=js"
export * from "./reply-loading.vue?vue&type=script&lang=js"
import style0 from "./reply-loading.vue?vue&type=style&index=0&id=6cbd1fdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd1fdb",
  null
  
)

export default component.exports